import FirebaseModel from "./firebasemodel";
export default class Group extends FirebaseModel {
    name;
    constructor(_model) {
        super(_model);
        this.name = this.data.name;
    }
}
